import * as e from "react";
import r from "../lib/IconBase.es.js";
import s from "../defs/Images.es.js";
const o = e.forwardRef((a, m) => /* @__PURE__ */ e.createElement(r, { ref: m, ...a, weights: s }));
o.displayName = "ImagesIcon";
const I = o;
export {
  I as Images,
  o as ImagesIcon
};
